<template>
  <CContainer
    class="datatable-container bg-white p-0 p-lg-4 kiosk-datatable overflow-auto"
  >
    <Loader :is-processing="isLoading" />
    <CRow class="d-flex justify-content-center mt-2">
      <CAlert
        v-if="reqResponse.message"
        class="mt-4"
        :color="reqResponse.type"
        :show="!!reqResponse.message"
      >
        {{ reqResponse.message }}
      </CAlert>
      <div class="status-guides-container mb-2 px-3 px-lg-0">
        <div class="tabs-filter-container">
          <div
            class="filter-tab"
            :class="{ active: kioskTab }"
            @click="setActiveKioskTab(1)"
          >
            Active
          </div>
          <div
            class="filter-tab"
            :class="{ active: !kioskTab }"
            @click="setActiveKioskTab(0)"
          >
            Inactive
          </div>
        </div>
      </div>
      <div class="table-responsive">
        <table v-if="kiosks">
          <thead>
            <tr>
              <th width="20" class="background-color-accent-blue-light" />
              <th width="120" class="background-color-kiosk-custom-white" />
              <th colspan="3" class="background-color-kiosk-cyan">
                <b>Start Kiosk via URL</b>
                <div @click="logOut">
                  <router-link
                    class="d-block"
                    to="/kiosk/login"
                    target="_blank"
                  >
                    {{ kioskLoginUrl }}
                  </router-link>
                </div>
                Launch Kiosk Via URL on any device
              </th>
              <th colspan="3" class="background-color-kiosk-blue">
                <b class="d-block">Start Kiosk Directly</b>
                Launch Kiosk on this device
              </th>
              <th class="background-color-kiosk-custom-white" width="50">
                Start time
              </th>
              <th class="background-color-kiosk-custom-white" width="50">
                End time
              </th>
              <th class="background-color-kiosk-custom-white">End Kiosk</th>
            </tr>
            <tr>
              <th width="20" class="background-color-accent-blue-light" />
              <th class="background-color-kiosk-custom-white" />
              <th
                colspan="1"
                class="background-color-accent-blue-light text-white fw-bold"
              >
                code
              </th>
              <th
                colspan="1"
                class="background-color-accent-blue-light text-white fw-bold"
              >
                send code via email
              </th>
              <th
                colspan="1"
                class="background-color-accent-blue-light text-white fw-bold"
              >
                regenerate code
              </th>
              <th colspan="3" class="background-color-blue-light" />
              <th colspan="3" class="background-color-kiosk-custom-white" />
            </tr>
          </thead>
          <tr v-for="(kiosk, index) in kiosks" :key="index">
            <td
              width="20"
              class="background-color-accent-blue-light text-center text-white"
            >
              <b>{{ index + 1 }}</b>
            </td>
            <td
              v-if="kiosk.room"
              class="background-color-kiosk-custom-white text-value-sm"
            >
              {{ kiosk.room ? kiosk.room.name : "" }}
            </td>
            <td
              v-else-if="kiosk.user"
              class="background-color-kiosk-custom-white text-value-sm"
            >
              {{ kiosk.user ? kiosk.user.first_name : "" }}
            </td>
            <td colspan="1" class="background-color-kiosk-cyan">
              {{ kiosk.passcode }}
            </td>
            <td colspan="1" class="background-color-kiosk-cyan">
              <button
                v-if="!kiosk.expired_date"
                class="btn-kiosk px-2 py-1"
                @click="sendCode(kiosk.class)"
              >
                Send
              </button>
              <div v-else>-</div>
            </td>
            <td colspan="1" class="background-color-kiosk-cyan">
              <button
                v-if="!kiosk.expired_date"
                class="btn-kiosk px-2 py-1"
                @click="regeneratePasscode(kiosk.id)"
              >
                Regenerate
              </button>
              <div v-else>-</div>
            </td>
            <td colspan="3" class="background-color-kiosk-blue text-center">
              <button
                v-if="!kiosk.expired_date && isKloginActive"
                class="btn-kiosk-launch px-2 py-1"
                @click="regeneratePasscode(kiosk.id, true)"
              >
                Launch
              </button>
              <div v-else>-</div>
            </td>
            <td
              colspan="1"
              :class="{
                'font-bold-text-black': !kiosk.expired_date && isKloginActive
              }"
            >
              {{
                kiosk.passcode_use
                  ? $helpers.transformDate(
                      kiosk.passcode_use,
                      "MM/DD/YYYY h:mm A"
                    )
                  : "-"
              }}
            </td>
            <td
              v-if="kiosk.passcode_use"
              colspan="1"
              :class="{
                'font-bold-text-black': !kiosk.expired_date && isKloginActive
              }"
            >
              {{
                kiosk.expired_date
                  ? $helpers.transformDate(
                      kiosk.expired_date,
                      "MM/DD/YYYY h:mm A"
                    )
                  : "Running"
              }}
            </td>
            <td
              v-else
              colspan="1"
              :class="{
                'font-bold-text-black': !kiosk.expired_date && isKloginActive
              }"
            >
              {{
                kiosk.expired_date
                  ? $helpers.transformDate(
                      kiosk.expired_date,
                      "MM/DD/YYYY h:mm A"
                    )
                  : "-"
              }}
            </td>
            <td
              colspan="1"
              :class="{
                'font-bold-text-black': !kiosk.expired_date && isKloginActive
              }"
            >
              <button
                v-if="!kiosk.expired_date"
                class="btn btn-trash d-flex align-items-center px-2 py-1"
                @click="triggerModal(kiosk.id)"
              >
                <span class="flaticon-trash me-1" /> End
              </button>
              <div v-else>Kiosk mode ended</div>
            </td>
          </tr>
        </table>
      </div>
    </CRow>
    <CModal
      backdrop="static"
      :visible="modal.isVisible"
      :close-on-backdrop="false"
      class="p-0"
      size="sm"
    >
      <div class="pt-4 px-3 create-popup-header">
        <div
          class="d-inline-block bg-gradient-blue text-white rounded-circle p-1 lh-normal cursor-pointer"
          @click="closeModal()"
        >
          <span class="close-icon" />
        </div>
      </div>
      <CRow class="justify-content-center">
        <CCol md="12">
          <h3 class="text-value-lg text-center">
            Are you sure you want to end Kiosk ?
          </h3>
          <div class="d-flex justify-content-center mt-4 mb-3">
            <button class="width180 btn text-graident-blue" @click="closeModal">
              Cancel
            </button>
            <button
              class="width180 ml-2 btn text-white bg-red"
              @click="endKiosk()"
            >
              End
            </button>
          </div>
        </CCol>
      </CRow>
      <template #footer-wrapper>
        <div />
      </template>
    </CModal>
  </CContainer>
</template>

<script>
import Loader from "@/components/Loader"
import { mapGetters } from "vuex"

export default {
  name: "KioskDataTable",
  components: {
    Loader
  },
  data() {
    return {
      isLoading: false,
      kiosk_room: null,
      modal: {
        kioskId: null,
        isVisible: false
      },
      reqResponse: {
        type: "",
        message: "",
        errors: {}
      },
      kioskTab: 1
    }
  },
  computed: {
    ...mapGetters({
      kiosks: "kiosks/kiosks",
      formSelectRooms: "rooms/formSelectRooms",
      activeKioskModuleOptions: "schools/activeKioskModuleOptions"
    }),
    isKloginActive() {
      return (
        this.activeKioskModuleOptions && !this.activeKioskModuleOptions.kurl
      )
    },
    kioskLoginUrl() {
      return document.location.origin + "/kiosk/login"
    }
  },
  mounted() {
    this.getKiosk()
  },
  methods: {
    getKiosk() {
      this.isLoading = true
      this.$store
        .dispatch("kiosks/getKiosks", { status: this.kioskTab })
        .then(() => {
          this.isLoading = false
        })
        .catch(() => {
          this.isLoading = false
        })
    },
    toggleTab(tab) {
      this.tabs[tab] = !this.tabs[tab]
    },
    create() {
      this.$store
        .dispatch("kiosks/createKiosk", { kiosk_room: this.kiosk_room })
        .then(() => {
          this.isLoading = false
        })
        .catch(() => {
          this.isLoading = false
        })
    },
    launch(code) {
      if (code) {
        this.$router.push({
          name: "Kiosk Login",
          query: { code }
        })
      }
    },
    triggerModal(kiosk_id) {
      this.modal.isVisible = true
      this.modal.kioskId = kiosk_id
    },
    endKiosk() {
      this.$store
        .dispatch("kiosks/deactivateKiosk", this.modal.kioskId)
        .then((response) => {
          const data = response.data.data
          if (data) {
            this.$store.commit("kiosks/UPDATE_KIOSK", data)
          }
          this.modal.isVisible = false
          this.modal.kioskId = null
          this.isLoading = false
        })
        .catch(() => {
          this.modal.isVisible = false
          this.modal.kioskId = null
          this.isLoading = false
        })
    },
    sendCode(kiosk_id) {
      this.isLoading = true
      this.resetResponseMessages()
      this.$store
        .dispatch("kiosks/sendCode", kiosk_id)
        .then(() => {
          this.isLoading = false
          this.setSuccessResponse("Successful sent email!")
          setTimeout(() => {
            this.resetResponseMessages()
          }, 1000)
        })
        .catch((err) => {
          this.isLoading = false
          const response = err.response.data
          this.setErrorResponse(response.message, response.errors)
        })
    },
    regeneratePasscode(kiosk_id, isLaunch) {
      this.$store
        .dispatch("kiosks/regeneratePasscode", kiosk_id)
        .then((response) => {
          if (isLaunch) {
            const data = response.data.data
            if (data.passcode) {
              this.launch(data.passcode)
            }
          }
          this.isLoading = false
        })
        .catch(() => {
          this.isLoading = false
        })
    },
    closeModal() {
      this.modal = {
        isVisible: false,
        kioskId: null
      }
    },
    setSuccessResponse(message) {
      this.reqResponse = {
        type: "success",
        message: message ? message : "Success!",
        errors: {}
      }
    },
    setErrorResponse(message, errors) {
      this.reqResponse = {
        type: "danger",
        message: message ? message : "Someting went wrong!",
        errors: errors ? errors : {}
      }
    },
    resetResponseMessages() {
      this.reqResponse = {
        type: "",
        message: "",
        errors: {}
      }
    },
    setActiveKioskTab(status) {
      this.kioskTab = status
      this.getKiosk()
    },
    logOut() {
      this.$store.dispatch("authentication/unauthorizeIfUserIsLogged")
    }
  }
}
</script>

<style lang="scss" scoped>
.font-bold-text-black {
  font-weight: bold;
  color: #000;
}
</style>
